export default {
  image: 'Gambar Header',
  bankName: 'Nama Bank',
  bankAcc: 'A/C',
  bankAtt: 'A/N',
  signer1Name: 'Penanda Tangan 1',
  signer1Position: 'Jabatan Penanda Tangan 1',
  signer2Name: 'Penanda Tangan 2',
  signer2Position: 'Jabatan Penanda Tangan 2',
  successUpdateMsg: 'Berhasil memperbarui data invoice',
}
